// extracted by mini-css-extract-plugin
export default {"cls1":"TagSelector-cls1_gL_","cls2":"TagSelector-cls2_nyk TagSelector-cls1_gL_"};